import * as React from 'react'
import { IProviderObject, IOperatorProviderObject, IProviderProductObject, IDriverSearchObject } from '../../types'
import { IMap } from '../../types/common'
import Close from '../icons/drivers/Close'
import EntityBottomPanel from '../ui/entity/EntityBottomPanel'
import EntityBottomPanelBtn from '../ui/entity/EntityBottomPanelBtn'
import PreloaderCircle from '../ui/PreloaderCircle'
import EditDriverBottomBar from './../drivers/EditDriverBottomBar'
import history from 'src/history'
import FloatingForm from '../ui/form/FloatingForm'
import { Select } from '@mobiscroll/react-latest'

export interface IEditDriverProductsProps {
  id: string
  organizationId: string
  allProducts: IProviderProductObject[]
  addProductsToDriver: (driverId: string, products: string[], organizationId: string) => Promise<any>
  removeProduct: (driverId: string, productId: string) => Promise<any>
  getDriverInfo: (id: string) => void
  driver: IDriverSearchObject
  submitBtnText: string
  loading: boolean
}

export interface IEditDriverProductsState {
  isSaving: boolean
  selectedProducts: IProductVariant[]
}

export const getDriverProductsPath = (driverId: string) => {
  return `/drivers/${driverId}/products`
}

class EditDriverProducts extends React.Component<IEditDriverProductsProps, IEditDriverProductsState> {
  constructor(props: IEditDriverProductsProps) {
    super(props)
    this.state = {
      isSaving: false,
      selectedProducts: []
    }
  }

  public componentDidMount() {
    this.props.getDriverInfo(this.props.id)
  }

  public render() {
    const { driver, allProducts } = this.props
    if (!driver) {
      return null
    }
    const operatorProducts = driver.products || []
    const selectedProducts = this.state.selectedProducts

    console.log(operatorProducts)
    console.log(selectedProducts)
    console.log(allProducts)

    const fetchAvailableProducts = () => {
      const availableProducts = Object.values(allProducts)
        .filter(p => {
          return (
            !operatorProducts.find(op => {
              if (op !== null && p !== null) {
                return op.id === p.id
              } else {
                return false
              }
            }) &&
            !selectedProducts.find(sp => {
              if (sp !== null && p !== null) {
                return sp.id === p.id
              } else {
                return false
              }
            })
          )
        })
        .map(p => ({
          text: p.name,
          value: p
        }))

      return availableProducts
    }

    const styles = {
      CirclePreLoader: {
        display: 'flex',
        paddingTop: '5px',
        flex: 1,
        justifyContent: 'center',
        alignment: 'center',
        width: '100%'
      }
    }

    if (this.props.loading) {
      return (
        <div style={styles.CirclePreLoader}>
          <PreloaderCircle loading={this.props.loading} />
        </div>
      )
    }

    return (
      <>
        <FloatingForm fullHeight={true}>
          <>
            <div className='form-modal-section full-section'>
              <div className='font-grey2 bold h5 mb1'>Add Product</div>
              <div className='col-12 bold h5 mt1 font-blue-grey'>
                <Select
                  data={fetchAvailableProducts()}
                  onChange={this.selectProduct}
                  touchUi={false}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  label={'Products'}
                  placeholder='Please select...'
                  labelStyle='stacked'
                  filter={true}
                  inputTyping={true}
                />
              </div>
              <div className='col-12 pt2 mt2 border-top'>
                <div className='font-grey2 bold h5'>Driver Products</div>
                {operatorProducts.map((product: IProductVariant) => this.renderProduct(product, true))}
                {selectedProducts.map((product: IProductVariant) => this.renderProduct(product))}
              </div>
            </div>
          </>
        </FloatingForm>
        <EditDriverBottomBar
          cancelPath={getDriverProductsPath(driver.id)}
          isSaving={this.state.isSaving}
          onSave={this.handleSubmit}
        />
      </>
    )
  }

  private renderProduct = (productVariant: IProductVariant, fromDriver: boolean = false) => {
    return (
      <span
        className='product-item'
        key={productVariant ? productVariant.id : `empty-product`}
        style={{ whiteSpace: 'nowrap' }}
      >
        {productVariant ? productVariant.name : ''}
        <span className='flex items-center' onClick={this.removeProduct(productVariant, fromDriver)}>
          <Close className='icon--9x9 ml1 cursor--pointer' />
        </span>
      </span>
    )
  }

  private handleSubmit = (e: React.FormEvent<any>) => {
    let productIds: string[] = []
    Object.values(this.state.selectedProducts).forEach(product => {
      productIds = productIds.concat(product.id)
    })

    this.setState({ isSaving: true })
    this.props
      .addProductsToDriver(this.props.id, productIds, this.props.organizationId)
      .then(() => {
        this.setState({ isSaving: false })
        const path = getDriverProductsPath(this.props.id)
        history.push(path)
      })
      .catch(error => {
        this.setState({ isSaving: false })
        console.error('Failed to update products: ', error)
      })
  }

  private selectProduct = (option: any) => {
    console.log(option)
    if (option && option.value !== null) {
      this.setState({
        selectedProducts: this.state.selectedProducts.concat(option.value)
      })
    }
  }

  private removeProduct = (product: IProductVariant, fromDriver: boolean) => () => {
    // If this is a newly selected product, remove from local state
    if (!fromDriver) {
      this.setState({
        selectedProducts: this.state.selectedProducts.filter(p => p.id !== product.id)
      })
      // When removing a product from the driver, we must call the API
    } else {
      this.setState({ isSaving: true })
      this.props.removeProduct(this.props.driver.id, product.id).then(() => {
        this.setState({ isSaving: false })
      })
    }
  }
}

//There are a few variations on ProviderProduct depending on how it
//was fetched from the API. The nested relation on the Operator model
//is slightly different than the models fetched via the Product index endpoint.
//This interface represents a common subset of fields
interface IProductVariant {
  id: string
  name: string
}

export default EditDriverProducts



// WEBPACK FOOTER //
// ./src/components/drivers/EditDriverProducts.tsx